export const Bio = {
    name: "Divyam Goyal",
    roles: [
      "Software Developer",
      "Full Stack Developer",      
      "UI/UX Designer",
      "Programmer",
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/divyam878",
    resume:
      "https://divyam-goyal-resume.tiiny.site",
    linkedin: "https://www.linkedin.com/in/divyam-goyal-792410175/",
    
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Next Js",
          image:
            "https://pbs.twimg.com/profile_images/1565710214019444737/if82cpbS_400x400.jpg",
        },
        {
          name: "Redux",
          image:
            "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
        },
       
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "TypeScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/768px-Typescript_logo_2020.svg.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
        {
          name: "Express Js",
          image:
            "data:image/png;base64,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",
        },
        
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "Postgresql",
          image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        },
        {
          name: "Firebase",
          image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        },
      ],
    },
    
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
        },
        {
          name: "Prisma",
          image:
            "https://seeklogo.com/images/P/prisma-logo-3805665B69-seeklogo.com.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Postman",
          image:
            "https://www.svgrepo.com/show/354202/postman-icon.svg",
        },
        {
          name: "Clerk",
          image:
            "https://images.clerk.com/static/logo-light-mode-400x400.png",
        },
        {
          name: "Google Apps Script",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_Apps_Script.svg/800px-Google_Apps_Script.svg.png",
        },

        {
          name: "Google Sheets",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Google_Sheets_logo_%282014-2020%29.svg/1498px-Google_Sheets_logo_%282014-2020%29.svg.png",
        },
        {
          name: "Google Colab",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Google_Colaboratory_SVG_Logo.svg/1200px-Google_Colaboratory_SVG_Logo.svg.png",
        },
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://pbs.twimg.com/profile_images/1331496488417984514/PfCDFZcg_400x400.jpg",
      role: "Associate Software Developer",
      company: "Nessco India Pvt. Ltd.",
      date: "Dec 2022 - Present",
      desc: "Working on Google Appscripts and Google Sheets.",
      skills: [
        "HTML",
        "CSS",
        "JavaScript",
        "Bootstrap",
        "Google Appscript",
        "Google Sheets",
        
      ],
      // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
    },
    
  ];
  
  export const achievements = [
    {
      id: 0,
      img: "https://sdfestaticassets-eu-west-1.sciencedirectassets.com/prod/616dd6edd1e2786afd1cba4e9cafce089e12d2e9/image/elsevier-non-solus.png",
      role: "An ensemble learning-based framework for breast cancer prediction",
      company: "Decision Analytics Journal",
      date: "Nov 2023",
      desc: "I am proud to share that my research paper, titled 'An Ensemble Learning-Based Framework for Breast Cancer Prediction,' has been successfully published in the Decision Analytics Journal. This paper represents a significant contribution to the field of healthcare analytics, specifically focusing on the development and implementation of an innovative ensemble learning framework for predicting breast cancer. The study delves into the intricate landscape of breast cancer prediction, employing advanced techniques to enhance accuracy and reliability. Through rigorous analysis and experimentation, the research not only adds valuable insights to the existing body of knowledge but also opens avenues for further exploration in the application of ensemble learning methodologies to improve medical diagnostics. Being published in the Decision Analytics Journal reflects the academic rigor and dedication invested in advancing the understanding of predictive analytics in the context of breast cancer, contributing meaningfully to the scientific discourse in this critical domain.",
      
      doc: "https://www.sciencedirect.com/science/article/pii/S2772662223002126?via%3Dihub",
      embed: "https://imgur.com/FIkBXJ8.jpg",
      
    },
    {
      id: 1,
      img: "https://images.credly.com/size/680x680/images/5fc2d535-e716-46c4-881a-f4822b8da0e5/Cognitive_Class_-_What_is_Data_Science.png",
      role: "Data Science Orientation",
      company: "IBM",
      date: "May 2020",
      desc: "I am pleased to announce that I have successfully earned a Data Science Orientation Certificate from IBM. This certification represents a comprehensive exploration of key concepts and foundational skills in the dynamic field of data science. Through this program, I gained valuable insights into data analysis, machine learning, and statistical modeling, leveraging IBM's industry-leading expertise and resources. The certification not only signifies my commitment to staying at the forefront of data science advancements but also demonstrates my proficiency in utilizing cutting-edge tools and techniques for extracting meaningful insights from complex datasets. This achievement reinforces my dedication to continuous learning and positions me as a competent professional in the ever-evolving landscape of data science.",
      
      doc: "https://www.credly.com/badges/370f1b06-28d9-44f6-a2cd-90e9dfd413fb/linked_in",
      embed: "https://imgur.com/McPSoZH.jpg",
      
    },
    {
      id: 2,
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/Coursera-Logo_600x600.svg/600px-Coursera-Logo_600x600.svg.png",
      role: "Python Data Structures",
      company: "Coursera",
      date: "May 2020",
      desc: "I am proud to have earned the Python Data Structures Certificate from Coursera. This certification validates my proficiency in utilizing fundamental data structures and algorithms in Python. Through practical applications, I gained valuable insights into lists, dictionaries, and tuples, enhancing my ability to solve real-world problems efficiently. This accomplishment underscores my commitment to continuous learning and highlights my expertise in employing Python for organized data manipulation in programming and data analysis.",
      
      doc: "https://www.coursera.org/account/accomplishments/verify/MKX7CCYHCJQE?utm_source=ln&utm_medium=certificate&utm_content=cert_image&utm_campaign=pdf_header_button&utm_product=coursee%20link%20here",
      embed: "https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~MKX7CCYHCJQE/CERTIFICATE_LANDING_PAGE~MKX7CCYHCJQE.jpeg",
    },
    {
      id: 3,
      img: "https://logowik.com/content/uploads/images/udemy-new-20212512.jpg",
      role: " The Complete JavaScript Course 2022",
      company: "Udemy",
      date: "Jan 2022",
      desc: "I am excited to share that I have successfully completed the Complete JavaScript Course on Udemy, earning a certificate that validates my comprehensive understanding of JavaScript. This course covered a wide range of topics, including the basics of JavaScript, DOM manipulation, asynchronous programming, and modern ES6+ features. The hands-on projects and practical examples provided in the course have equipped me with practical skills to develop dynamic and interactive web applications. This certificate underscores my commitment to staying updated with the latest technologies and my proficiency in using JavaScript for web development.",
      
      doc: "https://www.udemy.com/certificate/UC-9b9967fb-3ae6-4f73-8565-6ff85b0af001/",
      embed: "https://udemy-certificate.s3.amazonaws.com/image/UC-9b9967fb-3ae6-4f73-8565-6ff85b0af001.jpg?v=1643276725000",
    },
    
  ];

  export const education = [
    {
      id: 0,
      img: "https://www.juit.ac.in/front/images/logo.jpg",
      school: "Jaypee University of Information Technology, Solan",
      date: "June 2018 - June 2022",
      grade: "7.8 CGPA",
      desc: "I successfully completed my Bachelor of Technology in Computer Science at Jaypee University of Information Technology. During my academic journey, I actively participated in the photography club, fostering my creative skills and appreciation for visual arts. Alongside my engagement in the photography club, I delved into the world of coding, acquiring valuable programming knowledge that has since become an integral part of my skill set. This dual involvement in both the artistic and technical aspects of university life not only enriched my overall college experience but also shaped me into a well-rounded individual with a passion for both technology and the arts.",
      degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
    },
    {
      id: 1,
      img: "https://az704457.vo.msecnd.net/img/esstoragesv2/49013_d57a.jpg?Square60x60",
      school: "SR Global School, Jaipur",
      date: "Apr 2017 - Apr 2018",
      grade: "74%",
      desc: "I completed my class 12 high school education at SR Global School, Jaipur, where I studied Science with Physical Studies.",
      degree: "CBSE(XII), Science with Physical Studies",
    },
    {
      id: 2,
      img: "https://az704457.vo.msecnd.net/img/esstoragesv2/49013_d57a.jpg?Square60x60",
      school: "SR Global School, Jaipur",
      date: "Apr 2015 - Apr 2016",
      grade: "87.4%",
      desc: "I completed my class 10 education at SR Global School, Jaipur, where I studied Science with Physical Studies.",
      degree: "CBSE(X), Science with Physical Studies",
    },
  ];
  
  export const projects = [
    {
      id: 14,
      title: "Trip Management React App",
      date: "Mar 2024 - April 2024",
      description: "I developed a Trip Management System using React.js for the front end and MongoDB along with Google Apps Script for the back end. The system features a robust three-tier approval workflow involving HoD, HR, and accounts. Employee modules facilitate trip planning, payment tracking, and expense entry. The system generates comprehensive expense reports and offers user-friendly dashboards for better oversight. Automated processes and notifications enhance efficiency, contributing to effective trip management and transparent expense reporting. This modernized approach leverages React.js and MongoDB to provide a seamless and responsive user experience.",

      image:
        "https://i.imgur.com/4TdTYw2.png",
        tags: [        
          "React Js",
          "MongoDb",
          "Node Js",
          "Express Js",
          "Google app scripts",
          
        ],
      category: "web app",
      github: "",
      webapp: "",
    },
    {
      id: 13,
      title: "Form Builder",
      date: "Mar 2024 - April 2024",
      description:
        "I developed a form builder application using Next.js and TypeScript, with Prisma for storing user information. The app features a drag-and-drop interface for creating forms, allowing users to easily design their own forms. Once a form is created, users can share a link to their form and view submissions on a comprehensive dashboard. The application includes authentication via Clerk, ensuring secure access to user-specific features and data. This versatile tool simplifies form creation and management, making it accessible and efficient for all users.",
      image:
        "https://i.imgur.com/6Vmh7Cs.png",
      tags: [        
        "Next Js",
        "MySQL",
        "Node Js",
        "Express Js",
        "Prisma",
        "Clerk",
        "git",
      ],
      category: "web app",
      github: "",
      webapp: "",
    },
    {
      id: 9,
      title: "Trip Management",
      date: "Sept 2023 - Dec 2023",
      description: "Created a Trip Management System using Google Apps Script, JS, CSS, and HTML. Features include a three-tier approval workflow (HoD, HR, accounts), employee modules for trip planning, payment tracking, and expense entry. The system generates a comprehensive expense bill and provides user-friendly dashboards. Automated processes and notifications enhance efficiency, contributing to effective trip management and transparent expense reporting.",
      image: "https://imgur.com/mclBRiF.jpg",
      tags: [
        "HTML",
        "CSS",
        "JavaScript",
        "Google Sheets",
        "Google Appscript",
        "json",
      ],
      category: "android app",
      github: "",
      webapp: "",
    },
    {
      id: 12,
      title: "Disney+ Clone",
      date: "Oct 2023 - Nov 2023",
      description:
        "Developed a Disney+ clone using React.js, Firebase for authentication, and Redux for state management. The clone replicates Disney+ UI and features, incorporating user authentication through Firebase for login. Redux ensures efficient state management for a seamless user experience.",
      image:
        "https://res.cloudinary.com/dbxcernxw/image/upload/v1680855035/Mridul.Tech/Projects/disney_plus_clone_534ef56401_hqroy2.webp",
      tags: [        
        "React Js",
        "MongoDb",
        "Node Js",
        "Express Js",
        "Redux",
        "firebase",
        "git",
      ],
      category: "web app",
      github: "",
      webapp: "",
    },
   
    {
      id: 11,
      title: "Breast Cancer Prediction",
      date: "Jan 2022",
      description:
        "Implemented breast cancer prediction using ensemble learning, combining four models. Achieved maximum efficiency by leveraging the strengths of individual models. The ensemble approach enhances prediction accuracy for more reliable breast cancer diagnosis.",
      image:
        "https://imgur.com/NkaFeyb.jpg",
      tags: ["Python", "Keras", "TensorFlow", "Matplotlib", "seaborn"],
      category: "machine learning",
      github: "",
      webapp: "",
    },
    {
      id: 0,
      title: "Attendence Management",
      date: "Dec 2023 - Dec 2023",
      description:
        "Developed an Attendance Management System using Google Apps Script. The system streamlines attendance tracking, automates record-keeping, and offers real-time insights. Utilized Google Apps Script for seamless integration and efficiency in managing attendance records.",
      image:
        "https://imgur.com/CsENZYA.jpg",
      tags: ["HTML",
      "CSS",
      "JavaScript",
      "Google Sheets",
      "Google Appscript",
      "json",
    ],
      category: "android app",
      github: "",
      webapp: "",
      
    },
    {
      id: 1,
      title: "Guess The Number",
      date: "Oct 2022 - Oct 2022",
      description:
        "Created a guessing game using HTML, CSS, JavaScript, React, and Redux. Users aim to guess the correct number in the fewest attempts to achieve a high score. The combination of React for UI and Redux for state management enhances the gaming experience, providing a competitive edge to achieve the lowest attempts and secure a high score.",
      image:
        "https://imgur.com/BXiRkEQ.jpg",
      tags: [
        "React Js",
        "HTML",
        "CSS",
        "Javascript",
        "Redux",
        
      ],
      category: "web app",
      github: "",
      webapp: "",
    },
    {
      id: 2,
      title: "Bookworm",
      date: "Mar 2022 - Apr 2022",
      description:
        "Bookworm is an innovative e-commerce platform designed to cater to avid readers. The website offers not only an extensive collection of books but also provides concise summaries for users to make informed choices. Users can explore book summaries to understand the essence of each title and then seamlessly purchase their preferred books at the best prices available. Bookworm aims to create an enriching and user-friendly experience for book enthusiasts, combining the convenience of e-commerce with the value of insightful book summaries.",
      image:
        "https://imgur.com/1aRA8NM.jpg",
      tags: ["HTML", "CSS", "Javascript"],
      category: "web app",
      github: "",
      webapp: "",
      
      
    },
    {
      id: 3,
      title: "Kicks",
      date: "Jan 2023 - Jan 2023",
      description:
        "'Kicks' is a stylish and user-friendly e-commerce platform dedicated to shoe enthusiasts. Crafted with HTML, CSS, and JS, the website offers a seamless shopping experience for customers looking to purchase trendy footwear. With an intuitive interface, users can explore a diverse collection of shoes, from casual to athletic styles. The incorporation of HTML, CSS, and JS ensures a visually appealing and responsive design. 'Kicks' not only simplifies the online shopping process but also caters to the specific preferences of shoe lovers, making it a go-to destination for fashionable and comfortable footwear.",
      image:
        "https://imgur.com/ori2zp1.jpg",
      tags: ["HTML", "CSS", "Javascript"],
      category: "web app",
      github: "",
      webapp: "",
    },
    {
      id: 10,
      title: "Kaizen Report",
      date: "Jun 2023 - Jul 2023",
      description:
        "Designed a Kaizen Report Generator using Google Apps Script, HTML, CSS, and JS. This tool enables the creation of Kaizen reports based on employee ID, offering valuable insights into continuous improvement efforts. Employees can input their IDs, and the system dynamically generates comprehensive Kaizen reports, showcasing contributions to process enhancements. The integration of HTML, CSS, and JS ensures a user-friendly interface, while Google Apps Script handles data retrieval and report generation. This Kaizen Report Generator promotes a culture of continuous improvement by providing actionable insights and recognizing employees' impactful contributions.",
      image:
        "https://imgur.com/gSiGWvC.png",
      tags: ["HTML",
      "CSS",
      "JavaScript",
      "Google Sheets",
      "Google Appscript",
      "json",],
      category: "android app",
      github: "",
      webapp: "",
    },
    {
      id: 4,
      title: "Material Issue",
      date: "Aug 2023",
      description:
        "Developed a Material Issue System using Google Apps Script with HTML, CSS, and JS for efficient inventory management. This system facilitates the seamless issuance of materials, providing a user-friendly interface. Through the web application, users can request and track the issuance of materials, ensuring transparency in the process. The integration of HTML, CSS, and JS enhances the user experience, while Google Apps Script handles data processing and management. The Material Issue System streamlines and automates the material issuance process, contributing to improved inventory control and operational efficiency.",
      image:
        "https://imgur.com/OOnAONB.jpg",
      tags: ["HTML",
      "CSS",
      "JavaScript",
      "Google Sheets",
      "Google Appscript",
      "json",],
      category: "android app",
      github: "",
      webapp: "",
    },
    {
      id: 5,
      title: "Roll The Dice",
      date: "Jun 2022",
      description:
        "'Roll the Dice' is an exciting game where players strive to achieve the highest score without rolling a one. The game involves a strategic decision-making process: players can either continue rolling the dice to accumulate points or choose to hold, securing their current score. However, rolling a one results in losing all accumulated points. With a perfect blend of chance and strategy, 'Roll the Dice' offers an engaging and suspenseful gaming experience. The objective is to strike the right balance between risk and reward to maximize your score and avoid the dreaded one. ",
      image:
        "https://imgur.com/uAKDyno.jpg",
      tags: ["React Js",
      "HTML",
      "CSS",
      "Javascript",
      "Redux",],
      category: "web app",
      github: "",
      webapp: "",
    },
    {
      id: 6,
      title: "Mind",
      date: "Aug 2022",
      description:
        "'Mind' is a dynamic learning platform offering curated reading materials and quizzes on a wide array of topics, ranging from science to technology and beyond. Users can delve into rich content that caters to their interests and expands their knowledge base. The platform seamlessly combines educational materials with interactive quizzes, creating an engaging learning experience. Whether users are exploring scientific breakthroughs or tech innovations, 'Mind' serves as a versatile resource, fostering continuous learning and intellectual growth.",
      image:
        "https://imgur.com/xFW13VU.jpg",
      tags: ["HTML", "CSS", "Javascript"],
      category: "web app",
      github: "",
      webapp: "",
    },
    {
      id: 7,
      title: "Toolkit Management",
      date: "Feb 2023 - Feb 2023",
      description:
        "Designed a Toolkit Management System using Google Apps Script with HTML, CSS, and JS. This system streamlines the organization's toolkit inventory, providing an intuitive interface for users. Through the web application, users can easily manage toolkit items, track availability, and request or return tools. The integration of HTML, CSS, and JS ensures a user-friendly experience, while Google Apps Script handles data management efficiently. This Toolkit Management System enhances overall tool tracking and availability within the organization.",
      image:
        "https://imgur.com/J03squL.jpg",
      tags: ["HTML",
      "CSS",
      "JavaScript",
      "Google Sheets",
      "Google Appscript",
      "json",],
      category: "android app",
      github: "",
      webapp: "",
    },
    {
      id: 8,
      title: "Warrior High",
      date: "May 2022",
      description:
        "Warrior High presents an interactive website showcasing comprehensive details about the school's offerings and activities. The platform provides a detailed breakdown of pricing structures, allowing parents and guardians to make informed decisions about enrollment. Additionally, the website highlights the diverse range of extracurricular activities and educational programs offered by the school, fostering a holistic learning environment. Warrior High's website serves as a one-stop destination for prospective students and their families to explore the institution's offerings and gain insights into the vibrant educational experience it provides.",
      image:
        "https://imgur.com/ofQpkAV.jpg",
      tags: ["HTML", "CSS", "Javascript"],
      category: "web app",
      github: "",
      webapp: "",
    },
    
  ];
  
  // export const TimeLineData = [
  //   { year: 2017, text: "Started my journey" },
  //   { year: 2018, text: "Worked as a freelance developer" },
  //   { year: 2019, text: "Founded JavaScript Mastery" },
  //   { year: 2020, text: "Shared my projects with the world" },
  //   { year: 2021, text: "Started my own platform" },
  // ];